import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "nav__padding" }, null, -1)
const _hoisted_2 = { class: "nav__group" }
const _hoisted_3 = { class: "nav__group__item" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Article")
const _hoisted_5 = { class: "nav__group__item" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Talk")
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "nav__spacer" }, null, -1)
const _hoisted_8 = { class: "nav__group" }
const _hoisted_9 = { class: "nav__group__item no-mobile" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Read")
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "nav__group__item" }, [
  /*#__PURE__*/_createVNode("a", { href: "https://github.com/danfishgold/wikipedia-charts" }, "Edit")
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "nav__group__item no-mobile" }, [
  /*#__PURE__*/_createVNode("a", { href: "https://github.com/danfishgold/wikipedia-charts/commits/main" }, "View History")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "nav__padding" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("nav", null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: { name: 'root' },
          exact: "",
          class: { 'router-link-active': !_ctx.isOnTalk }
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, { to: { name: 'talk' } }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_7,
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode(_component_router_link, {
          to: _ctx.route.fullPath
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _hoisted_11,
      _hoisted_12
    ]),
    _hoisted_13
  ]))
}